import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
 
@Component({
  selector: 'app-prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.scss']
})
export class PromptDialogComponent implements OnInit {
 
  message:string;
  constructor(public dialogRef: MatDialogRef<PromptDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { 
    this.message=data;
  }
 
  
  ngOnInit() {

    document.getElementById("message").innerHTML = this.message
  }
  public closeDialog = () => {
    this.dialogRef.close();
  }
}